import React, { useState, useRef, useCallback } from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import MuiTab from "../../CommonComponents/Tab/MuiTab";
import CommonDescription from "../../CommonComponents/CommonDescription";
import useMediaQuery from "@mui/material/useMediaQuery";
import TableComponent from "../../CommonComponents/Table";
import CommonButton from "../../CommonComponents/CommonButton";
import AddIcon from "@mui/icons-material/Add";
import TuneIcon from "@mui/icons-material/Tune";
import DownloadIcon from "@mui/icons-material/Download";
import TextField from "@mui/material/TextField";
import TableGrid from "../../CommonComponents/TableGridView/TableGrid";
import {
  rowsData,
  tabsCaseManagement,
  tabs2CreateCase,
  CreateCaseTableGrid,
  CreateCaseMainTableData,
} from "../../constants/CreateCaseData";
import { openCaseActionList } from "../../constants/utils";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import CommonInput from "../../CommonComponents/CommonInput";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import useToaster from "../../customHook/useToaster";
import { addCase, getClaimDetails } from "../../Services/createCase.service";
import TableSkeleton from "../../CommonComponents/TableSkeleton";
import { caseDescriptionPut } from "../../Services/caseManagement.service";
import Loader from "../../CommonComponents/Loader/Loader";
const CreateCase = () => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchInputText, setSearchInputText] = useState("");
  const [secondTabVal, setSecondTabVal] = useState("Basic Details");
  const [secondTabIndex, setSecondTabIndex] = useState(0);
  const [firstTabVal, setFirstTabVal] = useState("Policy Number");
  const [firstTabIndex, setFirstTabIndex] = useState(0);
  const [displayFirstTab, setDisplayFirstTab] = useState(false);
  const [displaySecondTab, setDisplaySecondTab] = useState(false);
  const [claimDetail, setClaimDetail] = useState([]);
  const [onViewDetail, setOnViewDetail] = useState({});
  const [secondTabDetailData, setSecondTabDetailData] = useState({});
  const [openCollapse, setOpenCollapse] = useState(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const { showToast } = useToaster();
  const count = 90;

  const firstButtonClicked = () => {
    setPage(1);
  };
  const lastButtonClicked = () => {
    setPage(Math.ceil(count / rowsPerPage));
  };
  const handleNextButtonClick = () => {
    setPage((page) => page + 1);
  };
  const handleBackButtonClick = () => {
    setPage((page) => page - 1);
  };
  const onPageDropdownChange = (e) => {
    setPage(Number(e.target.value));
  };
  const secondTabChangeClickHandler = (event, newValue) => {
    setSecondTabVal(event.target.innerText);
    setSecondTabIndex(newValue);
    setOpenCollapse(false);
  };
  const onCellClicked = useCallback((e, colid, colValue, lobName, index) => {
    setOpenCollapse(index);
  }, []);
  const firstTabChangeClickHandler = (event, newValue) => {
    setFirstTabVal(event.target.innerText);
    setFirstTabIndex(newValue);
    setDisplaySecondTab(false);
    setDisplayFirstTab(false);
    setSecondTabVal("Basic Details");
    setSecondTabIndex(0);
    setSearchInputText("");
  };
  const gridViewTabs = [
    "Basic Details",
    "Policy Details",
    "Proposal Details",
    "Risk Details",
    "CHASE Smart",
  ];
  const onClickFirstPopper = (e, type) => {
    if (type === "createCase") {
      setLoader(true);
      const payload = { claimNumber: searchInputText };
      addCase(payload)
        .then((res) => {
          setLoader(false);
          if (res?.success) {
            navigate("/caseManagement", { replace: true });
            showToast("Case created successfully", "success", true);
          }
        })
        .catch((err) => {
          setLoader(false);
          showToast(err?.message, "error", true);
        });
      //
      // showToast("Case created successfully", "success", true);
      return;
    }
    setDisplaySecondTab(true);
    setSecondTabVal("Basic Details");
  };
  const createCaseClickHandler = () => {
    const payload = { claimNumber: searchInputText };
    addCase(payload)
      .then((res) => {
        if (res?.success) {
          navigate("/caseManagement", { replace: true });
          showToast("Case created successfully", "success", true);
        }
      })
      .catch((err) => showToast(err?.message, "error", true));
    //
    // showToast("Case created successfully", "success", true);
    setDisplaySecondTab(true);
    setSecondTabVal("Basic Details");
  };
  const onClickSecondPopper = (e, type) => {};
  const onCloseSecondPopper = () => {};
  const newCaseClickHandler = () => {
    navigate("/createCase");
  };
  const searchButtonClickHandler = () => {
    // api call based on searchInputText value
    setClaimDetail([]);
    setOnViewDetail({});
    if (searchInputText) {
      setDisplayFirstTab(true);
      getClaimDetails(searchInputText)
        .then((res) => {
          if (res?.success) {
            // res.data.srNo = 1;
            let resData = res?.data;
            setOnViewDetail(resData);
            const combinedData = {
              ...resData?.basic,
              ...resData?.policy,
              ...resData?.claim,
              ...resData?.risk,
              ...resData?.otherDetails,
              ...resData?.proposal,
              ...resData?.endorsement,
            };
            setDisplayFirstTab(true);
            setClaimDetail([combinedData]);
          }
        })
        .catch((err) => {
          setDisplayFirstTab(false);
          showToast(err?.response?.data?.message, "error", true);
        });
    }
  };

  const searchInputKeyDownHandler = (e) => {
    if (e.keyCode === 13) searchButtonClickHandler();
  };
  const searchInputClickHandler = (e) => {
    setSearchInputText(e.target.value);
    setDisplaySecondTab(false);
  };

  const tabsCreateCase = [
    {
      label: "Claim Number",
    },
  ];

  // const transformSectionDetails = (sectionDetails, sectionKey) => {
  //   return Object.entries(sectionDetails).map(([key, value]) => {
  //     const modifiedLabel = key.replace(/_/g, " ");
  //     return {
  //       label: modifiedLabel.charAt(0).toUpperCase() + modifiedLabel.slice(1),
  //       value: value || "",
  //     };
  //   });
  // };

  const normalizedTabValue = secondTabVal
    .replace(/\s*Details\s*/i, "")
    .toLowerCase();
  useEffect(() => {
    if (displaySecondTab) {
      tabs2CreateCase?.forEach((tab) => {
        const sectionKey = tab?.key;
        let sectionDetails = onViewDetail[sectionKey];
        if (sectionKey === normalizedTabValue) {
          if (normalizedTabValue === "claim") {
            sectionDetails = {
              ...sectionDetails,
              srNo: 1,
              view_details: "View Details",
              create_case: "Create Case",
            };
          }
          if (
            normalizedTabValue === "endorsement" &&
            Object.keys(sectionDetails)?.length
          ) {
            sectionDetails = {
              ...sectionDetails,
              srNo: 1,
              view_details: "View Details",
            };
          }
          setSecondTabDetailData(sectionDetails);
        }
      });
    }
  }, [displaySecondTab, secondTabIndex]);

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      {loader && <Loader />}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%%",
          ml: { sx: "0", sm: "2.4rem", md: "2.4rem" },
          mt: { sx: "0", sm: "2.4rem", md: "2.4rem" },
        }}
      >
        <Box sx={{ display: "block", width: "100%" }}>
          <Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "2rem",
                // display: { xs: "none", sm: "block", md: "block" },
              }}
            >
              Create Case
            </Typography>
          </Box>
        </Box>
      </Box>
      {/* <div style={{display:"flex",flexDirection:"column",background:"red"}}> */}
      <Box sx={{ width: "auto", marginLeft: "2.4rem" }}>
        <Box
          sx={{
            width: "55%",
            border: "1px solid #E8E8E8",
            borderRadius: "4px",
            marginTop: "2.4rem",
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "1.2rem",
              color: "#737D8C",
              marginLeft: "18px",
              marginTop: "16px",
            }}
          >
            Search by
          </Typography>
          <MuiTab
            tabs={tabsCreateCase}
            type="createCase"
            onClick={firstTabChangeClickHandler}
            activeTab={firstTabIndex}
          />
          {/* <CommonInput
                        onClick={onClickHandler}
                    /> */}
          <div
            style={{
              display: "flex",
              marginLeft: "18px",
              marginBottom: "11px",
              marginTop: "4px",
            }}
            className="input-div"
          >
            <div
              style={{
                marginRight: "12px",
                width: "51%",
                fontSize: "1.2rem",
                fontWeight: "700",
              }}
            >
              <CommonInput
                removeBackGround
                size={"small"}
                onChange={searchInputClickHandler}
                value={searchInputText}
                onKeyDown={searchInputKeyDownHandler}
              />
            </div>

            {/* <input
                            style={{
                                marginRight: "12px",
                                width: "278px",
                                border: "1px solid #E8E8E8",
                                borderRadius: "4px",
                                fontSize: "1.2rem",
                                color: "#737D8C",
                                padding: " 12px 8px",
                                fontWeight: "700",
                            }}
                        // size="small"
                        /> */}
            <div style={{ width: "41px" }}>
              <CommonButton
                label=""
                filledButton
                isIcon={true}
                // backgroundColor="#E8505B"
                // textColor="#E8E8E8"
                onClick={searchButtonClickHandler}
                iconName={
                  <SearchIcon
                    sx={{
                      fontSize: "2.8rem",
                      paddingTop: "0.4rem",
                      paddingBottom: "0.4rem",
                    }}
                  />
                }
                // onClick={newCaseClickHandler}
              />
            </div>
          </div>
        </Box>
        {displayFirstTab ? (
          <>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "1.2rem",
                color: "#737D8C",
                marginTop: "24px",
                marginBottom: "5px",
              }}
            >
              {`Search result for Claim number ${searchInputText}`}
            </Typography>
            {claimDetail?.length ? (
              <TableComponent
                stickyHeader={false}
                columnHeaderBackgroundColor={"#FCF7FF"}
                columnHeaderColor={"#242424"}
                columnHeaderFontWeight={600}
                columnBodyFontWeight={400}
                tablePagination={false}
                page={page}
                rowsPerPage={rowsPerPage}
                count={count}
                firstButtonClicked={firstButtonClicked}
                lastButtonClicked={lastButtonClicked}
                handleNextButtonClick={handleNextButtonClick}
                handleBackButtonClick={handleBackButtonClick}
                onPageDropdownChange={onPageDropdownChange}
                setPage={setPage}
                setRowsPerPage={setRowsPerPage}
                alternnateStyledRow={true}
                alternnateStyledRowColor={"#FBF5FF"}
                rowsData={claimDetail}
                columnsData={CreateCaseMainTableData[firstTabIndex]?.column}
                onClickFirstPopper={onClickFirstPopper}
                hideBorders={true}
                secondPopperListItem={openCaseActionList}
                onClickSecondPopper={onClickSecondPopper}
                onCloseSecondPopper={onCloseSecondPopper}
                onCellClicked={onCellClicked}
                popperContentMatch={"claim_xgen_number"}
                isCreateCase={true}
                // flagToHideView={true}
              />
            ) : (
              <TableSkeleton rows={1} pagination={false} />
            )}
          </>
        ) : null}
        {displaySecondTab ? (
          <>
            <MuiTab
              tabs={tabs2CreateCase}
              variant="standard"
              onClick={secondTabChangeClickHandler}
            />

            {gridViewTabs.includes(secondTabVal) ? (
              <TableGrid
                gridContent={secondTabDetailData}
                // isDocument={CreateCaseTableGrid[secondTabIndex].isDocuments}
                backgroundColor="#FFFFFF"
                boxShadow="0px 5px 25px rgba(0, 0, 0, 0.06)"
                isCreateCase
                // documentDetails={
                //   CreateCaseTableGrid[secondTabIndex].documentDetails
                // }
              />
            ) : (
              <TableComponent
                rowsData={[secondTabDetailData] || []}
                columnsData={CreateCaseTableGrid[secondTabIndex].column}
                TableCollapseContent={secondTabDetailData}
                TableCollapseContentDocument={false}
                tablePagination={false}
                hideBorders={true}
                onCellClicked={onCellClicked}
                open={openCollapse}
                setOpen={setOpenCollapse}
                paddingLeftHeaderStyledTableCell="3px"
                paddingHeaderStyledTableCell="4.5px"
                paddingBodyStyledTableCell="4.5px"
                columnHeaderColor={"#E42125"}
                columnHeaderFont="1.2rem"
                columnHeaderFontWeight={600}
                columnBodyFont="1.2rem"
                columnBodyFontWeight={500}
                paddingBody=".5rem"
                paddingHeader=".75rem"
                tableBoxShadow="0px 5px 25px rgba(0, 0, 0, 0.06)"
                tableBorder={""}
                tablePadding="1.5rem 0rem"
                createCaseClickHandler={createCaseClickHandler}
              />
            )}
          </>
        ) : null}
      </Box>
    </Box>
  );
};

export default CreateCase;
